import React from 'react';
import './Sections.css';

/* ── STATS BAR ── */
export function StatsBar() {
  const items = [
    { icon: '/icons/home/statsbar_01_ai-scoring.svg', label: 'AI Scoring',    sub: 'LLM-as-Judge + ROUGE' },
    { icon: '/icons/home/statsbar_02_122-tests.svg', label: '122+ Tests',   sub: 'Security Test Cases' },
    { icon: '/icons/home/statsbar_03_special-care.svg',   label: 'Special Care',  sub: 'OWASP LLM Top 10' },
    { icon: '/icons/home/statsbar_04_all-types.svg',label: 'All Types',    sub: '12 Bias Dimensions' },
    { icon: '/icons/home/statsbar_05_advanced-tech.svg',        label: 'Advanced Tech', sub: 'PDF Report Export' },
  ];
  return (
    <div className="stats-bar">
      <div className="stats-bar-inner">
        {items.map(i => (
          <div key={i.label} className="sb-item">
            <div className="sb-icon"><img src={i.icon} alt={i.label} /></div>
            <div><div className="sb-label">{i.label}</div><div className="sb-sub">{i.sub}</div></div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── ABOUT / PRACTICE SECTION ── (with dashboard mockup) */
export function About() {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-grid">
          <div>
            <div className="eyebrow reveal">About AccuGen</div>
            <h2 className="section-h reveal d1">A Platform Built<br />Around <em>You</em></h2>
            <p className="section-sub reveal d2">
              AccuGen delivers comprehensive AI quality and security evaluation,
              empowering enterprise teams to ship AI systems with confidence and compliance.
            </p>
            <div className="about-list">
              <div className="about-item reveal d1">
                <div className="about-icon"><img src="/icons/home/home_01_quality-score.svg" alt="Quality Service" /></div>
                <div>
                  <h4>Quality Service &amp; Response Accuracy</h4>
                  <p>Score AI responses for accuracy, hallucination, relevance, and completeness using ROUGE, BLEU, and LLM-as-Judge.</p>
                </div>
              </div>
              <div className="about-item reveal d2">
                <div className="about-icon"><img src="/icons/workflow/workflow_43_run-evaluation.svg" alt="Parallel Evaluation" /></div>
                <div>
                  <h4>Save Time with Parallel Evaluation</h4>
                  <p>Evaluate hundreds of prompts concurrently with real-time progress, automatic retry logic, and WAL-mode database for maximum throughput.</p>
                </div>
              </div>
              <div className="about-item reveal d3">
                <div className="about-icon"><img src="/icons/home/home_08_bias-detection.svg" alt="Bias Analytics" /></div>
                <div>
                  <h4>Real-Time Bias &amp; Fairness Analytics</h4>
                  <p>Detect bias across 12 dimensions — gender, race, religion, age, disability, geography, and cognitive bias.</p>
                </div>
              </div>
            </div>
            <div className="about-btns reveal d3">
              <a href="/contact" className="btn-navy" target="_blank" rel="noreferrer">Contact Us</a>
              <a href="#capabilities" className="btn-outline-navy">View Features</a>
            </div>
          </div>

          {/* Dashboard Mockup — exact replica of HTML mockup */}
          <div>
            <img src="/accugen-dashboard.png" alt="Accugen" />
          </div>
        {/*  <div className="about-visual reveal d2">
            <div className="dash-mockup">
              <div className="dm-topbar">
                <div className="dm-logo">
                  <div className="dm-logo-icon">A</div>
                  <span className="dm-logo-text">AccuGen <sup>v7.0</sup></span>
                </div>
                <div className="dm-topbar-mid">
                  <span className="dm-tb-label">PROJECT</span>
                  <div className="dm-tb-pill">Default Project</div>
                  <span className="dm-tb-label">PERSONA</span>
                  <div className="dm-tb-pill dm-tb-active">AI Security</div>
                </div>
                <div className="dm-run-btn">▶ Run Evaluation</div>
              </div>
              <div className="dm-body">
                <div className="dm-sidebar">
                  <div className="dm-nav-group">DASHBOARD</div>
                  <div className="dm-nav-item dm-nav-active"><span>◎</span> Benchmarks</div>
                  <div className="dm-nav-item">AI Security</div>
                  <div className="dm-nav-group">EVALUATIONS</div>
                  <div className="dm-nav-item"><span>▤</span> Business</div>
                  <div className="dm-nav-item"><span>△</span> AI Security</div>
                  <div className="dm-nav-group">CONFIGURATION</div>
                  <div className="dm-nav-item"><span>▤</span> Benchmarks</div>
                  <div className="dm-nav-item"><span>□</span> AI Security</div>
                  <div className="dm-nav-item"><span>○</span> Personas</div>
                </div>
                <div className="dm-main">
                  <div className="dm-page-title">Dashboard</div>
                  <div className="dm-page-sub">GenAI response quality overview across 8 evaluations · 317 prompts tested</div>
                  <div className="dm-kpis">
                    <div className="dm-kpi dm-kpi-purple">
                      <div className="dm-kpi-label">Quality Score</div>
                      <div className="dm-kpi-val">
                        <svg viewBox="0 0 36 36" width="36" height="36">
                          <circle cx="18" cy="18" r="14" fill="none" stroke="#e5e7eb" strokeWidth="4"/>
                          <circle cx="18" cy="18" r="14" fill="none" stroke="#10b981" strokeWidth="4"
                            strokeDasharray="87.96 100" strokeDashoffset="25" strokeLinecap="round"/>
                          <text x="18" y="22" textAnchor="middle" fontSize="9" fontWeight="700" fill="#10b981">90</text>
                        </svg>
                        <span className="dm-kpi-num">90</span>
                      </div>
                      <div className="dm-kpi-sub">Composite quality index</div>
                    </div>
                    <div className="dm-kpi dm-kpi-green">
                      <div className="dm-kpi-label">Pass Rate</div>
                      <div className="dm-kpi-big green">96.1%</div>
                      <div className="dm-kpi-sub">8 evaluations avg</div>
                    </div>
                    <div className="dm-kpi dm-kpi-purple">
                      <div className="dm-kpi-label">Accuracy</div>
                      <div className="dm-kpi-big purple">85.1%</div>
                      <div className="dm-kpi-sub">BERT + Semantic + Keyword</div>
                    </div>
                    <div className="dm-kpi">
                      <div className="dm-kpi-label">Hallucination-Free</div>
                      <div className="dm-kpi-big green">87.0%</div>
                      <div className="dm-kpi-sub">Entailment + Attribution</div>
                    </div>
                    <div className="dm-kpi">
                      <div className="dm-kpi-label">Relevance</div>
                      <div className="dm-kpi-big amber">77.3%</div>
                      <div className="dm-kpi-sub">Semantic + Intent match</div>
                    </div>
                  </div>
                  <div className="dm-charts-row">
                    <div className="dm-chart-card">
                      <div className="dm-chart-header">
                        <span className="dm-chart-title">Evaluation Trend</span>
                        <span className="dm-chart-sub">Last 7 runs</span>
                      </div>
                      <div className="dm-bars">
                        {['8 Apr','8 Apr','8 Apr','8 Apr','9 Apr','10 Apr','10 Apr'].map((d,i) => (
                          <div key={i} className="dm-bar-wrap">
                            <div className="dm-bar" style={{height:'80%'}} />
                            <div className="dm-bar-lbl">{d}</div>
                          </div>
                        ))}
                      </div>
                      <div className="dm-trend-footer">
                        <span>Best: <b style={{color:'#10b981'}}>96%</b></span>
                        <span>Avg: <b>96%</b></span>
                        <span>Worst: <b style={{color:'#ef4444'}}>96%</b></span>
                      </div>
                    </div>
                    <div className="dm-chart-card">
                      <div className="dm-chart-title" style={{marginBottom:14}}>Quality Breakdown</div>
                      <div className="dm-breakdown-rows">
                        {[
                          {label:'Accuracy',bg:'#7c3aed',pct:85},
                          {label:'Hallucination-Free',bg:'#10b981',pct:87},
                          {label:'Relevance',bg:'#6366f1',pct:77},
                          {label:'Pass Rate',bg:'#10b981',pct:96},
                        ].map(r => (
                          <div key={r.label} className="dm-brow">
                            <div className="dm-brow-label">{r.label}</div>
                            <div className="dm-brow-track"><div className="dm-brow-fill" style={{width:`${r.pct}%`,background:r.bg}} /></div>
                            <div className="dm-brow-pct">{r.pct}%</div>
                          </div>
                        ))}
                      </div>
                      <div className="dm-severity-row">
                        <span className="dm-sev dm-sev-high">HIGH 3</span>
                        <span className="dm-sev dm-sev-med">MEDIUM 1</span>
                        <span className="dm-sev dm-sev-min">MINOR 42</span>
                        <span className="dm-sev dm-sev-none">NONE 271</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="about-float-card">
              <div className="afc-icon" style={{background:'#d1fae5',fontSize:'18px'}}>✅</div>
              <div>
                <div className="afc-val" style={{color:'#059669'}}>96.1%</div>
                <div className="afc-label">Avg. Pass Rate · 317 prompts</div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}

/* ── CAPABILITIES ── */
export function Capabilities() {
  const caps = [
    { icon:'/icons/home/home_01_quality-score.svg',  title:'AI Response Quality', text:'Score AI responses across accuracy, hallucination, relevance, and completeness using algorithmic (ROUGE, BLEU, Semantic) or LLM-as-Judge evaluation methods.' },
    { icon:'/icons/home/home_07_security-vuln.svg',   title:'Security Vulnerability Testing', text:'Test against 14 attack categories including prompt injection, jailbreaking, data leakage, RAG poisoning, and adversarial formatting with 122+ test cases.' },
    { icon:'/icons/home/home_08_bias-detection.svg',  title:'Bias & Fairness Detection', text:'Multi-prompt evaluation across 12 bias dimensions — gender, race, religion, age, seniority, disability, geography, tone, and cognitive bias.' },
    { icon:'/icons/home/home_06_owasp-top10.svg',     title:'OWASP LLM Top 10 Mapping', text:'Every test maps to OWASP LLM Top 10 standards with severity ratings, remediation guidance, and compliance tracking for enterprise governance.' },
    { icon:'/icons/home/home_09_cicd.svg',            title:'Parallel Evaluation Engine', text:'Evaluate hundreds of prompts concurrently with real-time progress tracking, automatic retry logic, and WAL-mode database for high throughput.' },
    { icon:'/icons/home/home_10_reports.svg',         title:'Detailed Assessment Reports', text:'Interactive security assessment reports with collapsible categories, variant comparison tables, score donuts, filter controls, and one-click PDF export.' },
  ];
  return (
    <section id="capabilities" className="cap-section">
      <div className="container">
        <div className="cap-header">
          <div className="eyebrow reveal">Core Capabilities</div>
          <h2 className="section-h reveal d1" style={{textAlign:'center'}}>Everything You Need to<br />Validate Enterprise <em>AI</em></h2>
          <p className="section-sub reveal d2" style={{margin:'0 auto',textAlign:'center'}}>From response accuracy to security vulnerabilities, AccuGen provides comprehensive evaluation across every dimension that matters.</p>
        </div>
        <div className="cap-grid">
          {caps.map((c,i) => (
            <div key={c.title} className={`cap-card reveal${i%3===0?'':i%3===1?' d1':' d2'}`}>
              <div className="cap-icon"><img src={c.icon} alt={c.title} /></div>
              <h3>{c.title}</h3>
              <p>{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── SERVICES ── */
export function Services() {
  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="services-header">
          <div>
            <div className="eyebrow reveal">Enterprise</div>
            <h2 className="section-h reveal d1">Built for Enterprise<br /><em>AI Governance</em></h2>
            <p className="section-sub reveal d2">AccuGen serves teams across the AI lifecycle — from development to compliance.</p>
          </div>
        </div>
        <div className="services-grid">
          <div className="svc-card featured reveal">
            <div className="svc-icon svc-icon-dark"><img src="/icons/services/services_25_ai-security.svg" alt="Comprehensive AI Security" /></div>
            <h3>Comprehensive AI Security</h3>
            <p>End-to-end OWASP LLM Top 10 evaluation with 122+ test cases across 14 attack vectors. Detect prompt injection, jailbreaking, RAG poisoning, data leakage, and more.</p>
            <span className="svc-tag">122+ Tests · 14 Vectors</span>
          </div>
          <div className="svc-card reveal d1">
            <div className="svc-icon svc-icon-light"><img src="/icons/services/industry_01_healthcare.svg" alt="Healthcare & Life Sciences" /></div>
            <h3>Healthcare &amp; Life Sciences</h3>
            <p>Validate medical AI assistants against safety, accuracy, and regulatory compliance. Ensure AI responses don't fabricate clinical information or leak patient data.</p>
            <span className="svc-tag-blue">HIPAA · FDA · SOC 2</span>
          </div>
          <div className="svc-card reveal d2">
            <div className="svc-icon svc-icon-light"><img src="/icons/services/industry_02_financial.svg" alt="Financial Services" /></div>
            <h3>Financial Services</h3>
            <p>Test AI-powered customer service bots for accuracy in financial advice, resistance to social engineering, and compliance with regulatory guidelines.</p>
            <span className="svc-tag-blue">SOX · FINRA · GDPR</span>
          </div>
          <div className="svc-card reveal d1">
            <div className="svc-icon svc-icon-light"><img src="/icons/services/industry_03_engineering.svg" alt="AI Engineering Teams" /></div>
            <h3>AI Engineering Teams</h3>
            <p>Integrate security evaluation into your CI/CD pipeline. Run regression tests after every RAG pipeline update to catch quality regressions early.</p>
            <span className="svc-tag-blue">CI/CD · RAG · MLOps</span>
          </div>
          <div className="svc-card reveal d2">
            <div className="svc-icon svc-icon-light"><img src="/icons/services/industry_04_risk-compliance.svg" alt="Risk & Compliance" /></div>
            <h3>Risk &amp; Compliance</h3>
            <p>Generate OWASP-mapped assessment reports for internal audits, board presentations, and regulatory filings. Track security posture across releases.</p>
            <span className="svc-tag-blue">OWASP · ISO 27001 · NIST</span>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ── CTA STRIP ── */
export function CtaStrip() {
  return (
    <div className="cta-strip">
      <div className="cta-strip-inner">
        <div className="cta-strip-left">
          <h3>Ready to Evaluate Your <em>AI Systems?</em></h3>
          <p>Start your first evaluation today — enterprise-grade security testing in minutes.</p>
        </div>
        <div className="cta-strip-right">
          <div className="cta-phone">
            <div className="cta-phone-icon">📧</div>
            accugen@proautomate.ai
          </div>
          <a href="/contact" className="btn-cta-white" target="_blank" rel="noreferrer">
            Book Evaluation →
          </a>
        </div>
      </div>
    </div>
  );
}

/* ── OWASP SECURITY ── */
const owaspTiles = [
  { id:'LLM01', name:'Prompt Injection', icon:'/icons/security/security_31_llm01-prompt-injection.svg', count:'22 tests', active:true },
  { id:'LLM02', name:'Insecure Output',  icon:'/icons/security/security_32_llm02-insecure-output.svg',  count:'18 tests', active:true },
  { id:'LLM03', name:'Data Poisoning',   icon:'/icons/security/security_33_llm03-data-poisoning.svg',   count:'15 tests', active:true },
  { id:'LLM04', name:'Denial of Service',icon:'/icons/security/security_34_llm04-denial-of-service.svg',count:'4 tests',  active:true },
  { id:'LLM05', name:'Supply Chain',     icon:'/icons/security/security_35_llm05-supply-chain.svg',     count:'4 tests',  active:true },
  { id:'LLM06', name:'Info Disclosure',  icon:'/icons/security/security_36_llm06-info-disclosure.svg',  count:'14 tests', active:true },
  { id:'LLM07', name:'Plugin Design',    icon:'/icons/security/security_37_llm07-plugin-design.svg',    count:'37 tests', active:true },
  { id:'LLM08', name:'Excessive Agency', icon:'/icons/security/security_38_llm08-excessive-agency.svg', count:'4 tests',  active:true },
  { id:'LLM09', name:'Overreliance',     icon:'/icons/security/security_39_llm09-overreliance.svg',     count:'3 tests',  active:true },
  { id:'LLM10', name:'Model Theft',      icon:'/icons/security/security_40_llm10-model-theft.svg',      count:'Roadmap',  active:false },
];
export function OWASPSection() {
  return (
    <section id="security" className="owasp-section">
      <div className="owasp-inner">
        <div className="owasp-left">
          <div className="eyebrow">AI Security</div>
          <h2>Partnership with<br /><em>OWASP LLM Top 10</em></h2>
          <p>AccuGen maps every test to the OWASP LLM Top 10 framework — the industry standard for identifying and mitigating risks in large language model applications.</p>
          <div className="owasp-stat-row">
            {[{n:'9/10',l:'Categories'},{n:'122+',l:'Total Tests'},{n:'5+',l:'Severity Levels'},{n:'1',l:'On Roadmap'}].map(s => (
              <div key={s.l}><div className="os-stat-num">{s.n}</div><div className="os-stat-label">{s.l}</div></div>
            ))}
          </div>
          {/* <a href="/contact" className="btn-cta-white" style={{display:'inline-flex'}} target="_blank" rel="noreferrer">Learn More →</a> */}
        </div>
        <div className="owasp-right-grid">
          {owaspTiles.map((t,i) => (
            <div key={t.id} className={`owasp-tile${t.active?' active':' roadmap'} reveal d${(i%5)+1}`}>
              <div className="ot-emoji"><img src={t.icon} alt={t.name} /></div>
              <div className="ot-id">{t.id}</div>
              <div className="ot-name">{t.name}</div>
              <div className="ot-count">{t.count}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── WORKFLOW ── */
const wfSteps = [
  { n:'1', title:'Configure Persona',   text:'Point AccuGen to your AI endpoint. Configure auth, request templates, and scoring methods.' },
  { n:'2', title:'Select Test Library', text:'Choose pre-built OWASP/bias suites or upload custom test cases via CSV.' },
  { n:'3', title:'Run Evaluation',      text:'Execute all test prompts in parallel. AccuGen captures and scores every response in real time.' },
  { n:'4', title:'Review & Export',     text:'Drill into failures, compare bias variants, and export full OWASP-mapped PDF reports.' },
];
export function Workflow() {
  return (
    <section id="workflow" className="workflow-section">
      <div className="container">
        <div style={{textAlign:'center'}}>
          <div className="eyebrow reveal" style={{textAlign:'center'}}>How It Works</div>
          <h2 className="section-h reveal d1" style={{textAlign:'center'}}>From Setup to <em>Compliance</em><br />in 4 Steps</h2>
          <p className="section-sub reveal d2" style={{margin:'0 auto',textAlign:'center'}}>Simple, powerful workflow designed for enterprise AI teams of all sizes.</p>
        </div>
        <div className="wf-grid">
          {wfSteps.map((s,i) => (
            <div key={s.n} className={`wf-item reveal d${i+1}`}>
              <div className="wf-num-outer">
                <div className="wf-num-circle">{s.n}</div>
                <div className="wf-num-ring" />
              </div>
              <div className="wf-body">
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
